import './App.css'; // Import the default styles
import './group.css'; // Import the group styles
import React, { useState, useEffect } from 'react';
import { getNews, getVideo, getStory } from './services/api';
import { generateMatchupsForAllGroups } from './GenerateGroups';
import { doc, getFirestore, collection, getDocs, getDoc, addDoc, query, where } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';

 const WeeklyMatchupList = ({setGroup, onPageChange}) => {

  const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')) || {});
  const [myGroups, setMyGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(0);

  useEffect(() => {
  const fetchGroups = async () => {
    if (!user?.Email) return;

    try {
      const db = getFirestore();

      // Step 1: Get user's group IDs
      const userGroupsQuery = query(
        collection(db, 'UserGroups'),
        where('userEmail', '==', user.Email)
      );
      const userGroupsSnapshot = await getDocs(userGroupsQuery);
      const myGroupIds = userGroupsSnapshot.docs.map(doc => doc.data().groupId);

      // Step 2: Get all groups
      const allGroupsSnapshot = await getDocs(collection(db, 'Groups'));
      const allGroups = allGroupsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }))
      .sort((a, b) => a.name.localeCompare(b.name));

      // Step 6: Separate myGroups and otherGroups
      const myGroupsData = allGroups.filter(group => myGroupIds.includes(group.groupId));

      // Step 7: Set state
      setMyGroups(myGroupsData);
    } catch (error) {
      console.error('Error fetching groups:', error);
    } finally {
      setLoading(false);
    }
  };

  fetchGroups();
}, [refresh]);

const goToGame = (group) =>{
    setGroup(group);
    onPageChange('matchup');
}

  return (
    <div className="page">
        <div className="leaderboard">
            <h1>Select Group</h1>
              {myGroups.length === 0 || loading ? (
                    <div>{loading ? "Loading groups..." : "You are not in any groups."}</div>
              ) : (
                  <div className="mygroups groups">
                  {myGroups.map(group => (
                    <div className="group" key={group.id || Math.random()} onClick={() => goToGame(group)}>
                        <div className="groupIcon">
                            <div className={group.color}>
                                <img alt="Group Photo" src={(group.icon || "gibbs") + ".png"} />
                            </div>
                        </div>
                        <div className="groupName">
                            {group.name}
                        </div>
                         <div className="groupJoin button">
                            View Matchup
                        </div>
                    </div>
                  ))}
                  </div>
              )}
        </div>
    </div>
  );
};
export default WeeklyMatchupList;